export const IpRoute = {
  IpFullData: (): string => '/json',
};
